module.exports = __webpack_public_path__ + "assets/images/coin-bag.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-bag.png
// module id = 1509
// module chunks = 1